import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext";

function SunIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <path d="M21 14.5A8.5 8.5 0 1 1 9.5 3 7 7 0 0 0 21 14.5z" />
    </svg>
  );
}

function ThemeSwitcher() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <div
      role="group"
      aria-label={t("theme.switcherAria")}
      className="inline-flex shrink-0 items-center rounded-full border-2 border-mainDark p-0.5"
    >
      <button
        type="button"
        onClick={() => setTheme("light")}
        className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors duration-200 ${
          !isDark
            ? "bg-primary text-onPrimary"
            : "text-mainDark hover:text-mainBlue"
        }`}
        aria-label={t("theme.lightAria")}
        aria-pressed={!isDark}
      >
        <SunIcon className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => setTheme("dark")}
        className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors duration-200 ${
          isDark
            ? "bg-mainAccent text-ink"
            : "text-mainDark hover:text-mainBlue"
        }`}
        aria-label={t("theme.darkAria")}
        aria-pressed={isDark}
      >
        <MoonIcon className="h-4 w-4" />
      </button>
    </div>
  );
}

export default ThemeSwitcher;
